<template>
  <div
    class="prompt-page content"
    :class="{
      'mobile-prompt-page': isHXApp || isH5,
      'pad-app-prompt-page': isMGAppInPad,
    }"
  >
    <mobile-main
      v-if="orderInfo && (isHXApp || isH5)"
      :orderInfo="orderInfo"
      :msgInfo="msgInfo"
      :text-price="orderInfo.total_price / 100"
      :text-title="orderInfo.goods_title"
      :link-trade="'/trade'"
      :text-trade="'查看交易'"
      :link-study="'/my-course'"
      :text-study="'立即学习'"
    ></mobile-main>
    <div v-else class="content-wrap">
      <div class="result-info">
        <img
          v-if="msgInfo.type === 'success'"
          class="icon"
          src="@/assets/img/settle-in/success-icon.png"
          alt=""
        />
        <img
          v-else-if="msgInfo.type === 'error'"
          class="icon"
          src="@/assets/img/error-icon.png"
          alt=""
        />
        <img v-else-if="msgInfo.img" class="icon" :src="msgInfo.img" alt="" />
        <p>{{ msgInfo.msg }}</p>
      </div>
      <p class="link-wrap" v-if="msgInfo.linkList && msgInfo.linkList.length">
        <router-link
          v-for="item in msgInfo.linkList"
          :key="item.routeName"
          :to="{ name: item.routeName }"
          >{{ item.name }}</router-link
        >
      </p>
    </div>
  </div>
</template>

<script>
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import { isH5, isMobile, isHXApp, isMGAppInPad } from "@saas/components/src";
import MobileMain from "./MobileMain.vue";
export default {
  props: {
    msgInfo: {
      type: Object,
      default: () => {
        return {
          msg: "恭喜您，交易成功！",
          type: "success", //error
          img: "",
          linkList: [
            {
              routeName: "myCourse",
              name: "去学习中心",
            },
            {
              routeName: "Trade",
              name: "查看我的交易",
            },
          ],
        };
      },
    },
    orderInfo: {
      type: Object,
    },
  },
  components: {
    "mobile-main": MobileMain,
  },
  data: function () {
    return {
      isH5: isH5(),
      isMobile: isMobile(),
      isHXApp: isHXApp(),
      isMGAppInPad: isMGAppInPad(),
    };
  },
  mounted() {
    if (!this.isMobile) return;
    if (this.msgInfo.type === "success") {
      document.title = "支付成功";
    } else if (this.orderInfo?.state === 4) {
      document.title = "订单已关闭";
    } else {
      document.title = "超时未支付";
    }
    jsToFlutter("setTitle", { title: document.title });
  },
};
</script>

<style lang="scss" scoped>
.prompt-page {
  display: flex;
  justify-content: center;
  max-width: 768px;
  width: 100%;
  min-height: calc(100vh - 70px);
  &.pad-app-prompt-page {
    max-width: 375px;
  }
  &.mobile-prompt-page {
    min-height: 100vh;
  }
  padding: 45px 15px 10px;
  .content-wrap {
    display: none;
  }
  @media screen and (min-width: 768px) {
    .content-wrap {
      display: block;
    }
  }
  .content-wrap {
    .result-info {
      display: flex;
      align-items: center;
      font-size: 18px;
      line-height: 30px;
      .icon {
        height: 80px;
        margin-right: 20px;
      }
    }
    .link-wrap {
      padding-left: 120px;
      margin-top: 20px;
      a {
        font-size: 16px;
        margin-right: 30px;
        color: $saas-theme-color;
      }
    }
  }
}
@media (max-width: 767px) {
  .prompt-page {
    padding: 1.2rem 0.27rem 0;
    .content-wrap {
      .result-info {
        font-size: 0.43rem;
        line-height: 0.8rem;
        .icon {
          height: 1.6rem;
          margin-right: 0.4rem;
        }
      }
      .link-wrap {
        font-size: 0.4rem;
        display: flex;
        justify-content: space-around;
        text-align: center;
        padding-left: 0;
        a {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
